import SimpleBadge from "@/app/components/ui/Badges/SimpleBadge";
import ModalInformation from "@/app/components/ui/Modals/Information";
import { useModalActions } from "@/app/hooks/ui_hooks/useModalActions";
import { useModalState } from "@/app/hooks/ui_hooks/useModalState";
import { useRouter } from "@/app/hooks/useRouter";
import { FiEdit } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import { IViewCommentsModalProps } from "../interface";

export interface IMissingDetailsModalState {
  customerId: string;
  petId: string;
  missingDetails: {
    pet: {
      count: number;
      keys: Array<string>;
    };
    customer: {
      count: number;
      keys: Array<string>;
    };
  };
}

const MissingModalContent: React.FC<{
  show: boolean;
  contentFor: "CUSTOMER" | "PET";
  missingKeys: Array<string>;
  petId: string;
  customerId: string;
}> = ({ customerId, missingKeys, petId, show, contentFor }) => {
  const { getRouteKey } = useRouter();
  const navigate = useNavigate();
  const location = useLocation();
  const { setInvisible } = useModalActions("CUSTOMER_PET_MISSING_DETAILS");

  const handleAddPet = () => {
    let url = "";
    if (customerId && petId) {
      url = `${getRouteKey("ADD_PET", "url")}/${customerId}/${petId}`;
    } else {
      url = `${getRouteKey("ADD_PET", "url")}/${customerId}${location.search}`;
    }
    navigate(url);
  };

  const handleEdit = (editFor: "CUSTOMER" | "PET") => {
    let URLPrefix = "";
    let URLSuffix = "";
    if (editFor === "CUSTOMER") {
      URLPrefix = getRouteKey("EDIT_CUSTOMER", "url");
      if (customerId && petId) {
        URLSuffix = `${customerId}/${petId}`;
      } else {
        URLSuffix = `${customerId}${location.search}`;
      }
    } else {
      URLPrefix = getRouteKey("EDIT_PET", "url");
      if (customerId && petId) {
        URLSuffix = `${customerId}/${petId}`;
      } else {
        URLSuffix = `${customerId}${location.search}`;
      }
    }
    navigate(`${URLPrefix}/${URLSuffix}`);
  };
  return (
    show && (
      <div className="bg-white  sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-base font-semibold leading-6 text-gray-900">
            Update {contentFor === "CUSTOMER" ? "User" : "Pet"} Details
          </h3>

          <div className="mt-2 flex justify-start flex-wrap gap-y-2 items-center gap-x-2">
            {missingKeys?.map((detail, idx) => {
              return (
                <SimpleBadge
                  colorClassName="ring-pink-700/10 text-pink-700 bg-pink-50"
                  key={`${detail}:${idx}`}
                  label={detail}
                />
              );
            })}
          </div>
          <div className="mt-5 flex justify-start items-center gap-x-2">
            {!petId && contentFor === "CUSTOMER" && (
              <button
                onClick={() => {
                  setInvisible();
                  handleAddPet();
                }}
                type="button"
                className="inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                <span className=" flex justify-start items-center">
                  <FiEdit /> <span className="ml-1">Add Pet</span>{" "}
                </span>
              </button>
            )}
            <button
              onClick={() => {
                setInvisible();
                handleEdit(contentFor);
              }}
              type="button"
              className="rounded-md bg-indigo-50 px-3 py-2 text-sm font-semibold text-indigo-600 shadow-sm hover:bg-indigo-100"
            >
              <span className=" flex justify-start items-center">
                <FiEdit /> <span className="ml-1">Edit {contentFor === "CUSTOMER" ? "Customer" : "Pet"}</span>{" "}
              </span>
            </button>
          </div>
        </div>
      </div>
    )
  );
};

const MissingDetailsModal: React.FC<IViewCommentsModalProps> = () => {
  const { missingDetails, customerId, petId } = useModalState(
    "CUSTOMER_PET_MISSING_DETAILS",
  ) as IMissingDetailsModalState;

  return (
    <ModalInformation modalId="CUSTOMER_PET_MISSING_DETAILS" title={<span className="text-md"></span>}>
      <div className=" max-w-xl text-sm text-gray-500 ">
        <p>
          In order to create <strong>Booking</strong> all the <strong>user</strong> details and <strong>pet</strong>{" "}
          details should be filled. Please update the following details
        </p>
      </div>
      <MissingModalContent
        contentFor="CUSTOMER"
        show={missingDetails?.customer?.count > 0}
        customerId={customerId}
        petId={petId}
        missingKeys={missingDetails?.customer?.keys}
      />

      <MissingModalContent
        contentFor="PET"
        show={missingDetails?.pet?.count > 0}
        customerId={customerId}
        petId={petId}
        missingKeys={missingDetails?.pet?.keys}
      />
    </ModalInformation>
  );
};
export default MissingDetailsModal;
